import { giphyLightGrey } from '@giphy/js-brand'
import React, { SyntheticEvent } from 'react'
import styled, { css } from 'styled-components'
import { desktop } from 'shared/util/media-query'
import { useHistory } from 'react-router'

// Chris says this is it, universal font size for section headers
const SECTION_HEADER_FONT_SIZE = 15

const containerCss = css`
    font-size: ${SECTION_HEADER_FONT_SIZE}px;
    font-weight: 600;
    text-transform: capitalize;
    -webkit-font-smoothing: antialiased;
    color: ${giphyLightGrey};
    padding: 0 8px;
    ${desktop.css`
        padding: 0 8px 0 0;
    `}
    font-family: interface;
    display: flex;
    justify-content: flex-start;
    text-align: left;
`

const H2Container = styled.h2`
    ${containerCss}
`
const LinkContainer = styled.a`
    ${containerCss}
    cursor: pointer;
`
const Arrow = styled.div`
    font-size: 11px;
    margin-left: 3px;
    height: 13px;
    display: inline-block;
`

const Title = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 17px;
`

type Props = {
    label: string
    url?: string
    className?: string
    isHistoryPush?: boolean
    historyState?: any
}

const SectionHeader = ({ label, url = '', className = '', isHistoryPush, historyState = {} }: Props) => {
    const history = useHistory()
    const onClick = (e: SyntheticEvent) => {
        if (isHistoryPush) {
            e.preventDefault()
            history.push(url, historyState)
        }
    }
    return url ? (
        <LinkContainer href={url} className={className} onClick={onClick}>
            <h2>
                {label} <Arrow className="ss-icon ss-navigateright" />
            </h2>
        </LinkContainer>
    ) : (
        <H2Container className={className}>{label}</H2Container>
    )
}

export const SectionHeaderWithSeeAll = ({ label, url = '', className = '', isHistoryPush, historyState }: Props) => {
    return (
        <Title className={className}>
            <SectionHeader label={label} isHistoryPush={isHistoryPush} historyState={historyState} />
            <SectionHeader label="See All" url={url} isHistoryPush={isHistoryPush} historyState={historyState} />
        </Title>
    )
}
export default SectionHeader
